const relatedDegreeCollectionMetaData = [
  {
    roleSlug: 'bookkeeper-accounting-clerk',
    collectionId: 'GvKrqjsFSaihncSqiSh0nA',
    percentageOfBachelorJobPosting: 24.33,
    percentageOfMasterJobPosting: 2.03,
  },
  {
    roleSlug: 'android-developer-engineer',
    collectionId: 'law0PXGBTDazDllJZyHWYg',
    percentageOfBachelorJobPosting: 47.66,
    percentageOfMasterJobPosting: 12.77,
  },
  {
    roleSlug: 'application-developer-engineer',
    collectionId: '8qjPsKpcTCqhAFgcwiUbQg',
    percentageOfBachelorJobPosting: 65.35,
    percentageOfMasterJobPosting: 16.9,
  },
  {
    roleSlug: 'automation-engineer',
    collectionId: 'Sh74aD74TZOTttvoIYvwcw',
    percentageOfBachelorJobPosting: 62.19,
    percentageOfMasterJobPosting: 14.57,
  },
  {
    roleSlug: 'back-end-developer-engineer',
    collectionId: 'DcbzHmjUSc-boGAO5p79rg',
    percentageOfBachelorJobPosting: 51.44,
    percentageOfMasterJobPosting: 19.05,
  },
  {
    roleSlug: 'business-analyst-general',
    collectionId: '1dfGD7nyQ0iX9es-4R-nfg',
    percentageOfBachelorJobPosting: 68.29,
    percentageOfMasterJobPosting: 11.73,
  },
  {
    roleSlug: 'business-management-analyst',
    collectionId: '1dfGD7nyQ0iX9es-4R-nfg',
    percentageOfBachelorJobPosting: 68.29,
    percentageOfMasterJobPosting: 11.73,
  },
  {
    roleSlug: 'sales-development-representative',
    collectionId: '5aqGZjI8SMSicshHzeExzw',
    percentageOfBachelorJobPosting: 50.1,
    percentageOfMasterJobPosting: 5.83,
  },
  {
    roleSlug: 'business-intelligence-analyst',
    collectionId: 'xMQFnHuATjabIefhVg1qbQ',
    percentageOfBachelorJobPosting: 74.17,
    percentageOfMasterJobPosting: 28.08,
  },
  {
    roleSlug: 'career-counselor',
    collectionId: 'pfsTvlM9RuKGtrSvjDS1Gg',
    percentageOfBachelorJobPosting: 51.34,
    percentageOfMasterJobPosting: 18.31,
  },
  {
    roleSlug: 'cloud-architect',
    collectionId: '41L8sr_YR0On4ux2Iq4LEQ',
    percentageOfBachelorJobPosting: 59.87,
    percentageOfMasterJobPosting: 16.92,
  },
  {
    roleSlug: 'communications-public-relations-specialist',
    collectionId: 'EWNhTDAsQgKShNpvhBny4A',
    percentageOfBachelorJobPosting: 60.02,
    percentageOfMasterJobPosting: 10.19,
  },
  {
    roleSlug: 'compensation-benefits-analyst',
    collectionId: 'QThYKxdYRJeLdUFoKnKnHQ',
    percentageOfBachelorJobPosting: 71.33,
    percentageOfMasterJobPosting: 9.13,
  },
  {
    roleSlug: 'customer-service-representative',
    collectionId: 'sedsxa-cRAKY7xYN-s4psA',
    percentageOfBachelorJobPosting: 10.55,
    percentageOfMasterJobPosting: 1.14,
  },
  {
    roleSlug: 'cyber-security-analyst',
    collectionId: 'IfFW6J5eRU2vsQ2jc40uQg',
    percentageOfBachelorJobPosting: 66.69,
    percentageOfMasterJobPosting: 14.77,
  },
  {
    roleSlug: 'cyber-security-engineer',
    collectionId: 'IIZSZqYcSfuzjPMidawEjQ',
    percentageOfBachelorJobPosting: 65.65,
    percentageOfMasterJobPosting: 21.18,
  },
  {
    roleSlug: 'cyber-security-specialist-technician',
    collectionId: 'pfwDJlzBQBKzQEVBlXnvQw',
    percentageOfBachelorJobPosting: 59.6,
    percentageOfMasterJobPosting: 13.79,
  },
  {
    roleSlug: 'data-analyst',
    collectionId: 'p7iURn0rT0qvb6XqdcFH0A',
    percentageOfBachelorJobPosting: 64.86,
    percentageOfMasterJobPosting: 22.37,
  },
  {
    roleSlug: 'data-architect',
    collectionId: '4QBA5YOSTNyaMB7i09-B0g',
    percentageOfBachelorJobPosting: 51.46,
    percentageOfMasterJobPosting: 20.05,
  },
  {
    roleSlug: 'data-engineer',
    collectionId: 'oDHzcSfbRnu4JsROqgJWOQ',
    percentageOfBachelorJobPosting: 58.86,
    percentageOfMasterJobPosting: 20.64,
  },
  {
    roleSlug: 'data-manager',
    collectionId: 'xh6GRFK4RoCNtQuwHXYZRg',
    percentageOfBachelorJobPosting: 64.96,
    percentageOfMasterJobPosting: 28.11,
  },
  {
    roleSlug: 'data-scientist',
    collectionId: '6EMICSyxT1yaHgd_NhOuFw',
    percentageOfBachelorJobPosting: 54.35,
    percentageOfMasterJobPosting: 50.67,
  },
  {
    roleSlug: 'data-warehouse-developer',
    collectionId: '5wuZtB8CSrauKQdb2vSqEg',
    percentageOfBachelorJobPosting: 47.93,
    percentageOfMasterJobPosting: 6.94,
  },
  {
    roleSlug: 'devops-engineer',
    collectionId: 'ZIWTl8OYRfu_P-PQpOS38g',
    percentageOfBachelorJobPosting: 54.13,
    percentageOfMasterJobPosting: 12.49,
  },
  {
    roleSlug: 'content-creator',
    collectionId: 'vN2u8HorSkiRslPnjK9yvQ',
    percentageOfBachelorJobPosting: 30.16,
    percentageOfMasterJobPosting: 1.78,
  },
  {
    roleSlug: 'digital-marketing-specialist',
    collectionId: '7AWhzSj3QVCgTFxAydCJiw',
    percentageOfBachelorJobPosting: 54.36,
    percentageOfMasterJobPosting: 6.37,
  },
  {
    roleSlug: 'front-end-developer',
    collectionId: '5JUzGrfMSo6vLlYj0vX9sA',
    percentageOfBachelorJobPosting: 49.46,
    percentageOfMasterJobPosting: 13.62,
  },
  {
    roleSlug: 'full-stack-developer',
    collectionId: 'AvjMMx9OTdC4l70WqFjvCg',
    percentageOfBachelorJobPosting: 57.68,
    percentageOfMasterJobPosting: 18.56,
  },
  {
    roleSlug: 'graphic-designer-desktop-publisher',
    collectionId: 'blqv4zHgQhmxMkLanuT_tw',
    percentageOfBachelorJobPosting: 46.29,
    percentageOfMasterJobPosting: 3.17,
  },
  {
    roleSlug: 'human-resources-specialist',
    collectionId: 'fZuYBd33Q-OhDr11qTjFrg',
    percentageOfBachelorJobPosting: 46.89,
    percentageOfMasterJobPosting: 8.36,
  },
  {
    roleSlug: 'ios-developer-engineer',
    collectionId: 'hOXEDh-dSfmdmzR6l7_w9Q',
    percentageOfBachelorJobPosting: 46.87,
    percentageOfMasterJobPosting: 13.57,
  },
  {
    roleSlug: 'it-project-manager',
    collectionId: 'ZSt5LFYqRK-EHys7jxZ1Ig',
    percentageOfBachelorJobPosting: 61.53,
    percentageOfMasterJobPosting: 12.44,
  },
  {
    roleSlug: 'machine-learning-engineer',
    collectionId: '85e-vhVOQXuyRCu-9dZGPw',
    percentageOfBachelorJobPosting: 51.25,
    percentageOfMasterJobPosting: 48.4,
  },
  {
    roleSlug: 'mainframe-developer',
    collectionId: 'YlZN3OmjSMSmk7g-By6vsg',
    percentageOfBachelorJobPosting: 44.5,
    percentageOfMasterJobPosting: 5.05,
  },
  {
    roleSlug: 'marketing-analytics-specialist',
    collectionId: 'ctUjR50WSFeU8F5HwrAAWA',
    percentageOfBachelorJobPosting: 60.5,
    percentageOfMasterJobPosting: 33.81,
  },
  {
    roleSlug: 'medical-office-manager',
    collectionId: 'ZaATWtweRpCw6cll0EsBug',
    percentageOfBachelorJobPosting: 25.09,
    percentageOfMasterJobPosting: 1.94,
  },
  {
    roleSlug: 'network-systems-administrator',
    collectionId: 'zqq-OYatRseENzsvXk-7-A',
    percentageOfBachelorJobPosting: 54.16,
    percentageOfMasterJobPosting: 7.05,
  },
  {
    roleSlug: 'network-engineer-architect',
    collectionId: 'TjAxcEjSRfKypHu6NRi5AQ',
    percentageOfBachelorJobPosting: 60.37,
    percentageOfMasterJobPosting: 14.11,
  },
  {
    roleSlug: 'payroll-specialist',
    collectionId: '0P5m0Do9RTK4HSzal_Nrbw',
    percentageOfBachelorJobPosting: 32,
    percentageOfMasterJobPosting: 1.36,
  },
  {
    roleSlug: 'personal-trainer-fitness-instructor',
    collectionId: 'lgspNWpLTAq0eL8GHrlYjA',
    percentageOfBachelorJobPosting: 15.65,
    percentageOfMasterJobPosting: 0.87,
  },
  {
    roleSlug: 'product-manager',
    collectionId: 'ocLTsjvRRgCXF9O09r7M1w',
    percentageOfBachelorJobPosting: 65.4,
    percentageOfMasterJobPosting: 28.78,
  },
  {
    roleSlug: 'program-manager',
    collectionId: '6wHNhhGATC-SPnBcjQ7dHA',
    percentageOfBachelorJobPosting: 62.99,
    percentageOfMasterJobPosting: 29.49,
  },
  {
    roleSlug: 'project-manager',
    collectionId: 'tunETh33T0mOVjQFu4zCog',
    percentageOfBachelorJobPosting: 61.37,
    percentageOfMasterJobPosting: 14.62,
  },
  {
    roleSlug: 'python-developer',
    collectionId: 'k7UtHvRzTSuALBkvmx1cUw',
    percentageOfBachelorJobPosting: 39.59,
    percentageOfMasterJobPosting: 10.65,
  },
  {
    roleSlug: 'real-estate-agent',
    collectionId: 'rhMhhuQbRNCyFIPEheji8g',
    percentageOfBachelorJobPosting: 9.51,
    percentageOfMasterJobPosting: 1.18,
  },
  {
    roleSlug: 'sales-operations-specialist',
    collectionId: '1sYpgcfVRMOCAbit6vrApA',
    percentageOfBachelorJobPosting: 12.52,
    percentageOfMasterJobPosting: 0.34,
  },
  {
    roleSlug: 'sales-representative',
    collectionId: 'ijHhRtPUR7eNP-yaGBhcqQ',
    percentageOfBachelorJobPosting: 30.14,
    percentageOfMasterJobPosting: 1.47,
  },
  {
    roleSlug: 'scrum-master',
    collectionId: 'EfIRmDxIQtev9Uf9j2DGPQ',
    percentageOfBachelorJobPosting: 60.44,
    percentageOfMasterJobPosting: 10.97,
  },
  {
    roleSlug: 'social-media-strategist-specialist',
    collectionId: '7QMQsrQbQW2K4zkYyCRIXA',
    percentageOfBachelorJobPosting: 40.61,
    percentageOfMasterJobPosting: 4.62,
  },
  {
    roleSlug: 'software-developer-engineer',
    collectionId: 'vGWfyOBzTiOB256XYmDL7g',
    percentageOfBachelorJobPosting: 63.66,
    percentageOfMasterJobPosting: 20.43,
  },
  {
    roleSlug: 'solutions-application-architect',
    collectionId: 'Gfm36vGXTceTTvwsTxPRig',
    percentageOfBachelorJobPosting: 59.85,
    percentageOfMasterJobPosting: 18.36,
  },
  {
    roleSlug: 'statistician',
    collectionId: 'npqwJ51lSBWfrZdxsQuHMg',
    percentageOfBachelorJobPosting: 48.46,
    percentageOfMasterJobPosting: 52.65,
  },
  {
    roleSlug: 'logistics-supply-chain-analyst',
    collectionId: 'jUihbAbJQ7WmGp73VAwvkw',
    percentageOfBachelorJobPosting: 76.32,
    percentageOfMasterJobPosting: 16.19,
  },
  {
    roleSlug: 'tax-analyst-specialist',
    collectionId: '0H8bJsaTRk-rFcTOr0xcQg',
    percentageOfBachelorJobPosting: 77.64,
    percentageOfMasterJobPosting: 30.94,
  },
  {
    roleSlug: 'technology-consultant',
    collectionId: 'NtGYg-5dTtqIL2gRbCPRNA',
    percentageOfBachelorJobPosting: 65.04,
    percentageOfMasterJobPosting: 15.97,
  },
  {
    roleSlug: 'technical-support-engineer-analyst',
    collectionId: 'PfIl_fHHRNyv9aMf2iDa7Q',
    percentageOfBachelorJobPosting: 33.26,
    percentageOfMasterJobPosting: 3.55,
  },
  {
    roleSlug: 'computer-support-specialist',
    collectionId: 'PfIl_fHHRNyv9aMf2iDa7Q',
    percentageOfBachelorJobPosting: 33.26,
    percentageOfMasterJobPosting: 3.55,
  },
  {
    roleSlug: 'user-interface-user-experience-ui-ux-designer',
    collectionId: 'A3rmLHfFSRGt3qOt-yqV-w',
    percentageOfBachelorJobPosting: 53.86,
    percentageOfMasterJobPosting: 14.39,
  },
  {
    roleSlug: 'video-game-designer',
    collectionId: 'WxqjPLH6QpWSnYC0glkBnA',
    percentageOfBachelorJobPosting: 17.26,
    percentageOfMasterJobPosting: 7.1,
  },
  {
    roleSlug: 'video-game-developer',
    collectionId: '6Ua4fi3hQ0ao_WZIMVvZSw',
    percentageOfBachelorJobPosting: 53.49,
    percentageOfMasterJobPosting: 21.84,
  },
];

export const getRelatedDegreeCollectionMetadataByRoleSlug = (slug?: string) =>
  relatedDegreeCollectionMetaData.find((metadata) => metadata.roleSlug === slug);
